import { AttachmentForm, AttachmentType } from '../types/transaction';

/**
 * Attachment Form Options
 * Defines the physical form of the attachment
 */
export const ATTACHMENT_FORMS: { value: AttachmentForm; label: string }[] = [
  { value: 'digital', label: 'Arquivo Digital' },
  { value: 'physical', label: 'Documento Físico' },
  { value: 'digitalized', label: 'Digitalizado' },
];

/**
 * Attachment Type Options
 * Defines the document type/category
 */
export const ATTACHMENT_TYPES: { value: AttachmentType; label: string }[] = [
  { value: 'receipt', label: 'Comprovante' },
  { value: 'invoice', label: 'Nota Fiscal' },
  { value: 'bill', label: 'Boleto' },
  { value: 'voucher', label: 'Recibo' },
  { value: 'contract', label: 'Contrato' },
  { value: 'other', label: 'Outros' },
];

/**
 * Get label for attachment form
 */
export const getAttachmentFormLabel = (form: AttachmentForm | null | undefined): string => {
  if (!form) return 'Arquivo Digital';
  const option = ATTACHMENT_FORMS.find(f => f.value === form);
  return option?.label || 'Arquivo Digital';
};

/**
 * Get label for attachment type
 */
export const getAttachmentTypeLabel = (type: AttachmentType | null | undefined): string => {
  if (!type) return 'Outros';
  const option = ATTACHMENT_TYPES.find(t => t.value === type);
  return option?.label || 'Outros';
};

/**
 * Format file size in human-readable format
 */
export const formatFileSize = (bytes: number | null | undefined): string => {
  if (!bytes || bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))}${sizes[i]}`;
};

/**
 * Get file extension from filename
 */
export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '';
};

/**
 * Default values for new attachments
 */
export const DEFAULT_ATTACHMENT_FORM: AttachmentForm = 'digital';
export const DEFAULT_ATTACHMENT_TYPE: AttachmentType = 'other';
